/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_c_silent_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Using only the letters in SILENT (S, I, L, E, N, T), you can spell shorter words such as LINE, LENT, TIE, TIN, SIT, NIL, and ITS — each one already accounted for by SILENT's own six letters, with nothing extra needed.`)
};

const es_wu_c_silent_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usando solo las letras de SILENT (S, I, L, E, N, T), puedes formar palabras más cortas como LINE, LENT, TIE, TIN, SIT, NIL e ITS —cada una cubierta ya por las propias seis letras de SILENT, sin necesitar nada extra.`)
};

const de_wu_c_silent_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzt du nur die Buchstaben in SILENT (S, I, L, E, N, T), kannst du kürzere Wörter wie LINE, LENT, TIE, TIN, SIT, NIL und ITS bilden — jedes davon bereits durch SILENTs eigene sechs Buchstaben abgedeckt, ohne dass etwas Zusätzliches nötig ist.`)
};

const nl_wu_c_silent_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Met alleen de letters van SILENT (S, I, L, E, N, T) kun je kortere woorden spellen zoals LINE, LENT, TIE, TIN, SIT, NIL en ITS — elk al volledig te maken met SILENT's eigen zes letters, zonder iets extra's nodig te hebben.`)
};

const fr_wu_c_silent_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En n'utilisant que les lettres de SILENT (S, I, L, E, N, T), vous pouvez former des mots plus courts comme LINE, LENT, TIE, TIN, SIT, NIL et ITS — chacun déjà couvert par les six lettres propres de SILENT, sans rien ajouter.`)
};

const it_wu_c_silent_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usando solo le lettere di SILENT (S, I, L, E, N, T), puoi formare parole più corte come LINE, LENT, TIE, TIN, SIT, NIL e ITS — ognuna già interamente coperta dalle sei lettere di SILENT, senza bisogno di nulla in più.`)
};

const pt_br2_wu_c_silent_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usando apenas as letras de SILENT (S, I, L, E, N, T), você pode formar palavras mais curtas como LINE, LENT, TIE, TIN, SIT, NIL e ITS — cada uma já contemplada pelas próprias seis letras de SILENT, sem precisar de nada extra.`)
};

const pt_wu_c_silent_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usando apenas as letras de SILENT (S, I, L, E, N, T), pode soletrar palavras mais curtas como LINE, LENT, TIE, TIN, SIT, NIL e ITS — cada uma delas já coberta pelas próprias seis letras de SILENT, sem necessidade de nada extra.`)
};

const ja_wu_c_silent_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SILENTの文字（S, I, L, E, N, T）だけを使うと、LINE、LENT、TIE、TIN、SIT、NIL、ITSといった短い単語を綴ることができます — いずれもSILENT自身の6文字だけで賄えており、余分な文字は必要ありません。`)
};

const zh_wu_c_silent_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只用 SILENT 中的字母（S、I、L、E、N、T），可以拼出更短的单词，比如 LINE、LENT、TIE、TIN、SIT、NIL 和 ITS——每一个都完全由 SILENT 自身的六个字母组成，无需额外的字母。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_c_silent_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_c_silent_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_c_silent_faq2_a", locale)
	if (locale === "en") return en_wu_c_silent_faq2_a(inputs)
	if (locale === "es") return es_wu_c_silent_faq2_a(inputs)
	if (locale === "de") return de_wu_c_silent_faq2_a(inputs)
	if (locale === "nl") return nl_wu_c_silent_faq2_a(inputs)
	if (locale === "fr") return fr_wu_c_silent_faq2_a(inputs)
	if (locale === "it") return it_wu_c_silent_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_wu_c_silent_faq2_a(inputs)
	if (locale === "pt") return pt_wu_c_silent_faq2_a(inputs)
	if (locale === "ja") return ja_wu_c_silent_faq2_a(inputs)
	return zh_wu_c_silent_faq2_a(inputs)
};